<script>
import dataTable from "../components/dataTable";
import auctionEdit from "../components/auctionEdit";

export default {
  name: "auction-table",
  components: {
    dataTable,
    auctionEdit,
  },
  props: {},
  data: function() {
    return {
      showAuctionEdit: false,
      auctionRefresh: 0,
    };
  },
  methods: {
    async onClickNewAuctionCreate() {
      this.$store.commit("setAuctionEditVisible", true);
      var template = await this.$store.dispatch("getRequest", { controller: "auction", method: `template` });
      var now = new Date();
      template.auctionStart = now.addHours(1).toISOString();

      console.log("43");

      this.$store.commit("setActiveAuction", template);
    },
    refreshTable: function() {
      this.auctionRefresh++;
      this.$emit("refreshAuctionTable");
    },
    onRowClick: function(id) {
      this.$router.push(`/auction/${id}`);
    },
    onHideAuctionEdit: function() {
      this.$store.commit("setActiveAuction", false);
      this.$store.commit("setAuctionEditVisible", false);
    },
    async onEdit(id) {
      var result = await this.$store.dispatch("getRequest", { controller: "auction", method: `GetAuction/${id}` });
      var editAuction = result.auction;
      if (editAuction.status != "Unstarted" && this.isProd) {
        this.$store.commit("setMessage", { title: "Unable To Edit", type: "error", content: `Auctions can only be edited if they have not yet started.` });
      } else {
        this.$store.commit("setActiveAuction", editAuction);
        this.$store.commit("setAuctionEditVisible", true);
      }
    },
    async onDelete(id, status) {
      if (status != "Unstarted") {
        this.$store.commit("setMessage", { title: "Unable To Delete", type: "error", content: `Auctions can only be deleted if they have not yet started.` });
      } else {
        await this.$store.dispatch("deleteRequest", { controller: "auction", method: `Delete/${id}` });
        this.$store.commit("setActiveAuction", null);
        this.refreshTable();
      }
    },
  },
  computed: {
    userRole: function() {
      return this.$store.state.role;
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
    auctionEditVisible: function() {
      return this.$store.state.auctionEditVisible;
    },
    availableRequirements: function() {
      return this.$store.state.availableRequirements;
    },
    currentEnvironment: function() {
      return process.env.VUE_APP_ENVIRONMENT;
    },
    isProd: function() {
      return this.currentEnvironment == "production";
    },
  },
};
</script>
<template>
  <div>
    <div style="margin-bottom:0.5rem;" v-if="!isOwner">
      <button
        :title="[availableRequirements.length <= 0 ? 'No Suitable requirements found - Please ensure vessels have been shortlisted in the SeaPortal' : 'Click to Create Auction']"
        :disabled="availableRequirements.length <= 0"
        v-on:click="onClickNewAuctionCreate"
        type="button"
        class="btn-round btn btn-light"
      >
        Create Auction<i class="fas fa-plus-circle icon-right"></i>
      </button>
    </div>
    <data-table
      v-if="!isOwner"
      :columns="[
        { field: 'requirementSummary', class: 'col-6  col-lg-9', title: 'Auction Summary' },
        { field: 'status', class: 'col-3 col-lg-1', title: 'Status', type: 'status' },
        { field: 'bidCount', class: 'col-2 col-lg-1 text-right', title: 'Bids' },
        { field: 'actionButton', class: 'col-1', title: '', type: 'action' },
      ]"
      dataSource="auction"
      :refresh="auctionRefresh"
      v-on:onRowClick="onRowClick"
      v-on:edit="onEdit"
      v-on:delete="onDelete"
      idField="id"
      rowTitle="Click to go to auction"
      deleteWarning="Are you sure you want to delete this auction?"
    >
    </data-table>
    <data-table
      v-else
      :columns="[
        { field: 'requirementSummaryWithCharterer', class: 'col-6  col-lg-8', title: 'Auction Summary' },
        { field: 'shortlistedVessels', class: 'col-4 col-lg-3', title: 'Shortlisted Vessel(s)' },
        { field: 'status', class: 'col-2 col-lg-1', title: 'Status', type: 'status' },
      ]"
      dataSource="auction"
      :refresh="auctionRefresh"
      v-on:onRowClick="onRowClick"
      rowTitle="Click to go to auction"
      idField="id"
      deleteWarning="Are you sure you want to delete this auction?"
    >
    </data-table>
    <auction-edit :visible="auctionEditVisible" v-on:hide="onHideAuctionEdit" v-on:refreshTable="refreshTable"></auction-edit>
  </div>
</template>
